export enum AffiliateQueryParams {
    ChannelWeb = '&utm_channel=Web&utm_source={source}',
    ChannelApp = '&utm_channel=App&utm_source={source}',
}
